import { z } from 'zod';

const relatedTransaction = z.object({
  txnHash: z.string(),
  chain: z.string(),
  _id: z.string(),
  tokens: z.array(z.object({ address: z.string(), value: z.number() })),
});

const involvedWalletSchema = z.object({
  address: z.string(),
  chain: z.string().toLowerCase(),
});

const allHacksSchema = z.array(
  z.object({
    _id: z.string(),
    entityName: z.string(),
    hackName: z.string(),
    amountLost: z.number(),
    amountRecovered: z.number(),
    startDate: z.string().datetime(),
    endDate: z.string().datetime(),
    tags: z.array(z.string()),
    hackMethod: z.string(),
    chains: z.array(z.string()),
  })
);
const hackDetailsSchema = z.object({
  _id: z.string(),
  entityName: z.string(),
  hackName: z.string(),
  amountLost: z.number(),
  amountRecovered: z.number(),
  startDate: z.string().datetime(),
  endDate: z.string().datetime(),
  tags: z.array(z.string()).default([]),
  hackMethod: z.string(),
  chains: z.array(z.string()),

  description: z.string().optional(),
  announcementLink: z.string(),
  entityLink: z.object({
    _id: z.string(),
    logo: z.string(),
    name: z.string(),
  }),
  hackTxns: z.array(relatedTransaction),
  refundTxns: z.array(relatedTransaction).default([]),
  walletsInvolved: z.array(involvedWalletSchema).default([]),
  detailedDescription: z.object({ ops: z.array(z.any()) }).optional(),
});

export default { hackDetailsSchema, allHacksSchema };
